import { useState } from "react";
import { Reveal } from "./anim";

export const LOOKUPS = {
  single: "pleasure_portal_single",
  triple: "pleasure_portal_triple",
};

const CHECKOUT_URL = "https://orgasmicoffers.com/pleasureportal";

export function BuyButton({ lookupKey, children, className = "", testid, outline = false }) {
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);
    window.location.href = CHECKOUT_URL;
  };

  return (
    <button
      data-testid={testid}
      aria-label={typeof children === "string" ? children : "Buy now"}
      onClick={handleClick}
      disabled={loading}
      className={`inline-flex items-center justify-center gap-2 px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] ff-sans ${
        outline ? "btn-outline-gold" : "btn-gold"
      } ${className}`}
    >
      {loading ? "Opening secure checkout…" : children}
    </button>
  );
}

export function HeroOfferStack() {
  return (
    <div className="space-y-4">
      <Reveal delay={0.9} y={24}>
        <div className="border hairline-champagne bg-white/[0.02] p-6 sm:p-7">
          <div className="flex items-baseline justify-between gap-4">
            <p className="text-[11px] uppercase tracking-[0.3em] text-champagne/70 ff-sans" style={{ color: "#f7e7ce" }}>
              One Pleasure Portal
            </p>
            <div className="text-right">
              <p className="text-[11px] ff-sans text-[#f7e7ce]/40 line-through">$127</p>
              <p className="ff-serif text-4xl font-light gold-text" data-testid="hero-single-price">$97</p>
            </div>
          </div>
          <p className="mt-2 text-right text-[9px] uppercase tracking-[0.25em] ff-sans" style={{ color: "#ff7fbf" }}>
            Limited-time offer
          </p>
          <BuyButton testid="hero-buy-single-btn" lookupKey={LOOKUPS.single} outline className="mt-4 w-full">
            Enter the Portal — $97
          </BuyButton>
        </div>
      </Reveal>

      <Reveal delay={1.05} y={24}>
        <div className="glow-border glow-soft p-6 sm:p-7" data-testid="hero-best-value-card">
          <p className="text-center text-[11px] uppercase tracking-[0.35em] gold-text ff-sans font-semibold">
            ★ Best Value ★
          </p>
          <p className="mt-3 text-center ff-serif text-3xl font-light leading-tight text-[#fdfbf7]">
            Buy 2. <span className="italic gold-text">Get 1 Free.</span>
          </p>
          <div className="mt-4 flex items-baseline justify-between gap-4">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#f7e7ce]/70 ff-sans">3 Pleasure Portals</p>
            <p className="ff-serif text-5xl font-light gold-text" data-testid="hero-triple-price">$222</p>
          </div>
          <div className="mt-1 flex items-center justify-between text-xs ff-sans text-[#f7e7ce]/60">
            <span>Regular value $381</span>
            <span className="uppercase tracking-[0.2em]" style={{ color: "#ff7fbf" }}>You save $159</span>
          </div>
          <p className="mt-2 text-right text-[10px] uppercase tracking-[0.25em] ff-sans" style={{ color: "#ff7fbf" }}>
            Just $74 each — limited time
          </p>
          <BuyButton testid="hero-buy-triple-btn" lookupKey={LOOKUPS.triple} className="mt-4 w-full">
            Get 3 for $222
          </BuyButton>
        </div>
      </Reveal>

      <Reveal delay={1.2} y={16}>
        <p className="text-center text-[10px] uppercase tracking-[0.3em] text-[#f7e7ce]/50 ff-sans">
          Secure Checkout • Discreet Shipping • Limited Release
        </p>
        <a
          data-testid="hero-skool-link"
          href="https://www.skool.com/love-vortex-6983"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 block text-center text-[10px] uppercase tracking-[0.3em] ff-sans transition-opacity duration-300 hover:opacity-70"
          style={{ color: "#ff7fbf" }}
        >
          ★ Free Tantra course on Skool included with every order ★
        </a>
      </Reveal>
    </div>
  );
}
